export const TRC_ROUTES = Object.freeze({
	HOME: '/',
	TRC_HOME: '/trc',
	STUDIO_HUB_HOME: '/studio-hub',
	LESSON_PLANS: 'lesson-plans',
	PROGRESSIVE_LESSON_PLANS: 'progressive-lesson-plans',
	VIDEOS: 'videos',
	RESOURCES: 'resources',
	VIEW_ALL: 'view-all',
	SINGLE_LESSON_PLAN: 'lesson-plans/:id',
	SINGLE_PROGRESSIVE_LESSON_PLAN: 'progressive-lesson-plans/:id',
	SINGLE_VIDEO: 'videos/:id',
	SINGLE_RESOURCE: 'resources/:id',
	SEARCH: 'trc-result',
	ACCESS: 'access',
	RESUBMIT: 'resubmit'
});
